import anime from "animejs/lib/anime.es";

const blobs = document.querySelectorAll<HTMLElement>('.blob');

blobs?.forEach(blob => {
    const parent = blob.parentElement;
    if (!parent) {
        return;
    }

    const parentRect = parent.getBoundingClientRect();
    const parentWidth = parentRect.width;
    const parentHeight = parentRect.height;
    const childRect = blob.getBoundingClientRect();
    const childWidth = childRect.width;
    const childHeight = childRect.height;

    function moveChild(element: HTMLElement) {
        const randomX = Math.floor(Math.random() * (parentWidth - childWidth));
        const randomY = Math.floor(Math.random() * (parentHeight - childHeight));

        anime({
            targets: element,
            translateX: randomX,
            translateY: randomY,
            duration: 5000,
            easing: 'easeInOutQuad',
            complete: () => moveChild(element),
        });
    }

    moveChild(blob);
});
